export const pages = [
  { en: '/', pl: '/pl/' },
  { en: '/about/', pl: '/pl/o-nas/' },
  { en: '/blog/', pl: '/pl/blog/' },
  { en: '/contact/', pl: '/pl/kontakt/' },
  { en: '/careers/', pl: '/pl/kariera/' },
  { en: '/terms/', pl: '/pl/regulamin/' },
  { en: '/offer/', pl: '/pl/oferta/' },
];